<template>
  <!-- Search -->
  <v-list
    two-line
    class="mt-3 mb-5">
    <v-list-tile>
      <!-- TODO: Text/Translate -->

      <v-text-field
        v-model.trim="search"
        label="Was suchst du?"
        solo
        autofocus
        :error-messages="searchErrors"

        prepend-inner-icon="fas fa-search"
        :append-icon="search ? 'fas fa-times' : ''"
        @click:append="delSearch"
        @change="$v.search.$touch()"
        @keyup="toTimelineFilter"
        @blur="toTimelineFilter"></v-text-field>
    </v-list-tile>
   
    <v-layout class="text-xs-center pa-4">
      <v-flex xs12>
        <article class="font-italic primary--text">
          <!-- TODO: Text/Translate -->

          <p>Suche nach einem Begriff deiner Wahl!</p>
          <p>
            <!-- TODO: Text/Translate -->

            Egal ob Namen, ID, Ort, Kategorie, Titel oder Beschreibung... <br> Hier findest du was du suchst!
          </p>
        </article>
      </v-flex>
    </v-layout>
  </v-list>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import { minLength, maxLength } from 'vuelidate/lib/validators'

import { orderBy, union } from 'lodash'


export default {
  data() {
    return {
      search: ''
    }
  },
  validations: {
    search: {
      minLength: minLength(3),
      maxLength: maxLength(50)
    },
  },
  computed: {
    ...mapState({
      user: state => state.user.user,
      isMobile: state => state.isMobile,
      searchFilter: state => state.timeline.timelineFilter.searchFilter,
      loadedEvents: state => state.timeline.loadedEvents,
      loadedMoments: state => state.timeline.loadedMoments,
    }),
    ...mapGetters({
      loading: 'loading',
      loadingEvents: 'loadingEvents',
      loadingMoments: 'loadingMoments'
    }),
    searchErrors() {
      // <!-- TODO: Text/Translate -->

      const errors = []
      if (!this.$v.search.$dirty) return errors
      !this.$v.search.maxLength && errors.push('Search must not have more than ' + this.$v.search.$params.maxLength.max + ' letters.')
      !this.$v.search.minLength && errors.push('Search must have at least ' + this.$v.search.$params.minLength.min + ' letters.')
      return errors
    },
  },

  watch: {
    searchFilter() {
      if (this.searchFilter === '') {
        this.search = ''
      }
    }
  },
  methods: {
    ...mapMutations([
      'setFilter',
    ]),
    delSearch() {
      this.search = ''
      this.setFilter({ searchFilter: this.search.replace(/\s\s+/g, ' ') })
    },

    toTimelineFilter() {
      if (!this.$v.search.$invalid) {
        this.setFilter({ searchFilter: this.search.replace(/\s\s+/g, ' ') })
      }
      
    }
    
  }
}
</script>
